<sl-skeleton [effect]="effect"></sl-skeleton>
